//
//
//
//
//
//
//

import AQToggle from "@/components/Generics/AQToggle/AQToggle.vue";

export default {
    components: {
        AQToggle
    },
    props: {
        uuid: {
            type: String
        },
        value: {
            default: false
        },
        readonly: {
            type: Boolean
        }
    },
    data() {
        return {

        };
    },
    computed: {
        computedValue: {
            get() {
                return this.value || false;
            },
            set(v) {
                if (this.readonly) {
                    return false;
                }

                this.$emit("input", v);
            }
        }
    }
};
